var divider_viewer_rtlignore_default = {
  "divider-container": "_82tuh",
  "divider-container--double": "zo-Os",
  "divider": "XI9bM",
  "divider--single": "_7fWJI",
  "divider--double": "MYmI3",
  "divider--dashed": "r2Oh2",
  "divider--dotted": "kGutZ",
  "divider--small": "-ICHm",
  "divider--medium": "J-7RY",
  "divider--large": "_4Z77p",
  "divider--left": "hssfI",
  "divider--center": "_3U9GX",
  "divider--right": "x5XXY",
  "svgFixerContainer": "iDMON",
  "emptyChar": "rs6rB"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
